import axios, { AxiosResponse } from "axios";
import { Image } from "element-ui";
import { objectToQuery } from "../../ObjectToQuery";

class Response {
    id: any;
    headline!: boolean;
    title: string;
    short_description: string;
    description: string;
    image: Image;
    slug: string;
    created_at: Date;
}

export enum BannerSize {
    ALL = "all",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large"
}

class getMagazinePostsQuery {
    _start? = 0;
    _limit? = 8;
    _sort? = "updated_at:DESC"
}

export function getMagazinePosts(params?: getMagazinePostsQuery): Promise<AxiosResponse<Response[]>> {    
    const query = `https://qwerty.pchas.ir/posts?confirmed=true&categories.slug=tayeh&${objectToQuery(params)}`;
    return axios.get(query);
}